import axios from 'axios';
import { PROFESSION, COURSE } from '../database/profession';

class Course {
  // 获得 professionName
  static getProfessionName(professionId) {
    for (let i = 0, { length } = PROFESSION; i < length; i += 1) {
      if (PROFESSION[i].id === professionId) {
        return PROFESSION[i].name;
      }
    }
    return '';
  }

  // 获得 courseName
  static getCourseName(courseId) {
    return COURSE[courseId];
  }

  // 获得 professionName 列表
  static getProfessionNameList() {
    const list = [];
    PROFESSION.forEach((item) => {
      list.push(item.name);
    });
    return list;
  }

  // 根据 professionId 获得 profession
  static getProfessionById(professionId) {
    for (let i = 0, { length } = PROFESSION; i < length; i += 1) {
      if (PROFESSION[i].id === professionId) {
        return PROFESSION[i];
      }
    }
    return {};
  }

  // 根据 professionId 获得 profession 下的 courseList
  static getCourseListById(professionId) {
    const profession = this.getProfessionById(professionId);
    return profession.course;
  }

  // 开体验课
  static openCourse(professionId, phone) {
    return axios({
      method: 'get',
      url: 'https://cj.tibaitong.com/market/openingCourse',
      params: {
        professionId,
        phone,
        isValid: 0,
        source: 3,
      },
    });
  }

  // 获取视频信息
  static getVideoInfo(videoId) {
    return axios.get(
      `https://cj.tibaitong.com/api/excellent/detail?videoExcellentId=${videoId}`,
    );
  }

  // 获取视频列表
  static getPlayList(professionId) {
    return axios.get(
      `https://cj.tibaitong.com/api/excellent/list?professionId=${professionId}`,
    );
  }

  // 获取公开课直播列表
  static getLiveList(professionId, page) {
    return axios.get(
      `https://cj.tibaitong.com/api/main/freeLiveList/${professionId}/${page}`,
      // { timeout: 1000 },
    );
  }
}

export default Course;
